module.exports = __webpack_public_path__ + "img/presale-detail2.c76672fb.png";